// Photos for the Gallery page.
// Add new gallery photos to this folder (src/assets/img/gallery/), then
// import them below and add an entry to the `galleryImages` array.

import baptism from "./Baptism.JPG";
import bigGroup1 from "./BigGroup1.JPG";
import boonvilleSignWEunice from "./BoonvilleSignWEunice.jpeg";
import eunicePreaching from "./EunciePreaching.jpg";
import euniceKneeling from "./EuniceKneeling.JPG";
import euniceOnStage from "./EuniceOnStage.JPG";
import eunicePreaching2 from "./EunicePreaching2.PNG";
import euniceSoloMissouriCorrectionalSign from "./EuniceSoloMissouriCorrectionalSign.jpeg";
import euniceAndJohnnySolo from "./EuniceandJohnnySolo.jpg";
import godLookingForUnlikelyPeople from "./GodLookingForUnlikelyPeople.jpeg";
import group6 from "./Group6.jpeg";
import groupCafeteria1 from "./GroupCafeteria1.jpg";
import groupPrayer from "./GroupPrayer.JPG";
import groupPrayer2 from "./GroupPrayer2.jpeg";
import groupPrayer3 from "./GroupPrayer3.jpeg";
import johnnyHandInTheAir from "./JohnnyHandintheAir.jpg";
import johnnyOnStage from "./JohnnyOnStage.jpeg";
import johnnyPreaching from "./JohnnyPreaching.JPG";
import riseUpHats from "./RiseUpHats.jpg";
import servantLeadership1 from "./ServantLeadership1.jpg";
import servantLeadership2 from "./ServantLeadership2.jpeg";
import servantLeadership3 from "./ServantLeadership3.jpeg";
import servantLeadership4 from "./ServantLeadership4.jpeg";
import servantLeadershipCert from "./ServantLeadershipCert.JPG";
import service1 from "./Service1.jpg";
import service2 from "./Service2.jpeg";
import service3 from "./Service3.jpeg";
import service4 from "./Service4.JPG";
import service5 from "./Service5.JPG";
import smallGroup1 from "./SmallGroup1.jpg";
import smallGroup2 from "./SmallGroup2.jpg";
import smallGroup3 from "./SmallGroup3.JPG";
import smallGroup4 from "./SmallGroup4.jpg";
import smallGroup5 from "./SmallGroup5.jpg";
import smallGroup6 from "./SmallGroup6.JPG";
import womensFreshStart from "./WomensFreshStart.jpg";
import church from "./church.jpg";
import prisoners from "./prisoners.jpg";

export const galleryImages = [
    { src: baptism, alt: "Baptism service" },
    { src: bigGroup1, alt: "Large group gathering" },
    { src: boonvilleSignWEunice, alt: "Eunice at the Boonville Correctional Center sign" },
    { src: eunicePreaching, alt: "Eunice preaching" },
    { src: euniceKneeling, alt: "Eunice kneeling in prayer" },
    { src: euniceOnStage, alt: "Eunice speaking on stage" },
    { src: eunicePreaching2, alt: "Eunice preaching", objectPosition: "top" },
    { src: euniceSoloMissouriCorrectionalSign, alt: "Eunice at a Missouri Correctional Center sign" },
    { src: euniceAndJohnnySolo, alt: "Eunice and Johnny", objectPosition: "center 25%" },
    { src: godLookingForUnlikelyPeople, alt: "\"God is looking for unlikely people\" sign" },
    { src: group6, alt: "Group gathering" },
    { src: groupCafeteria1, alt: "Group gathering in the cafeteria" },
    { src: groupPrayer, alt: "Group prayer" },
    { src: groupPrayer2, alt: "Group prayer" },
    { src: groupPrayer3, alt: "Group prayer" },
    { src: johnnyHandInTheAir, alt: "Johnny with his hand raised in worship" },
    { src: johnnyOnStage, alt: "Johnny speaking on stage" },
    { src: johnnyPreaching, alt: "Johnny preaching" },
    { src: riseUpHats, alt: "Rise Up Ministry hats" },
    { src: servantLeadership1, alt: "Servant Leadership Summit" },
    { src: servantLeadership2, alt: "Servant Leadership Summit" },
    { src: servantLeadership3, alt: "Servant Leadership Summit" },
    { src: servantLeadership4, alt: "Servant Leadership Summit" },
    { src: servantLeadershipCert, alt: "Servant Leadership certificate" },
    { src: service1, alt: "Prison chapel service" },
    { src: service2, alt: "Prison chapel service" },
    { src: service3, alt: "Prison chapel service" },
    { src: service4, alt: "Prison chapel service" },
    { src: service5, alt: "Prison chapel service" },
    { src: smallGroup1, alt: "Small group gathering" },
    { src: smallGroup2, alt: "Small group gathering" },
    { src: smallGroup3, alt: "Small group gathering" },
    { src: smallGroup4, alt: "Small group gathering" },
    { src: smallGroup5, alt: "Small group gathering" },
    { src: smallGroup6, alt: "Small group gathering" },
    { src: womensFreshStart, alt: "Women's Fresh Start program" },
    { src: church, alt: "Church" },
    { src: prisoners, alt: "Prisoners" },
];
